var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._g(_vm._b({staticClass:"d-inline-block"},'router-link',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{staticClass:"shrink",attrs:{"src":`https://cdn.vuetifyjs.com/docs/images/logos/vuetify-logo-${_vm.theme.isDark ? 'dark' : 'light' }-text.svg`,"alt":_vm.$t('logo'),"max-width":"148","width":"148"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }